import React, { useContext } from 'react';
import { ShadowContext } from './ShadowContext';
import { values } from './default';
var BoxShadow = function (_a) {
    var blur = _a.blur, spread = _a.spread, color = _a.color, offsetY = _a.offsetY, offsetX = _a.offsetX, children = _a.children;
    var c = useContext(ShadowContext);
    color = color || c.color || values.color;
    blur = blur || c.blur || values.blur;
    spread = spread || c.spread || values.spread;
    offsetX = offsetX || c.offsetX || values.offsetX;
    offsetY = offsetY || c.offsetY || values.offsetY;
    var styles = {
        boxShadow: "".concat(offsetX, "px ").concat(offsetY, "px ").concat(blur, "px ").concat(spread, "px ").concat(color || c.color)
    };
    var child = React.Children.only(children);
    var objectStyles = Object.assign({}, styles);
    return React.createElement(React.Fragment, null, React.cloneElement(child, { style: objectStyles }));
};
export default BoxShadow;
